import Http from '@/support/http';

export default {
	state: {
		list: {}
	},
	getters: {
		evaluationQuestionsList: (state) => state.list,
		evaluationQuestions: (state) => state.list.questions,
		evaluationStudentsQuestions: (state) => state.list.students,
		evaluationType: (state) => state.list.type
	},
	mutations: {
		SET_EVALUATION_QUESTION_LIST(state, payload) {
			state.list = payload;
		},
		SET_EVALUATION_QUESTION_ANSWER(state, payload) {

			const student = state.list.students.filter((student) => student.student.studentId === payload.student)[0];
			const question = student.questions.filter((question) => question.id === payload.question)[0];

			question.answer = payload.answer;

		}
	},
	actions: {
		setEvaluationQuestionAnswer(context, payload) {
			context.commit('SET_EVALUATION_QUESTION_ANSWER', payload);
		},
		clearEvaluationQuestion(context) {
			context.commit('SET_EVALUATION_QUESTION_LIST', {});
		},
		getEvaluationQuestion(context, payload) {

			if (payload.userId && payload.schoolClassId) {

				const route = `v2/evaluation-question/user/${ payload.userId }?schoolClassId=${ payload.schoolClassId }`;

				return Http.get(route).then((response) => {

					context.commit('SET_EVALUATION_QUESTION_LIST', response.data);

					return response;

				});

			}

		},
		saveEvaluationQuestion(context, payload) {

			if (payload.data && payload.userId && payload.schoolClassId) {

				const route = `v2/evaluation-question/user/${ payload.userId }`;
				const data = payload.data;

				delete data.questions;

				return Http.post(route, {
					userId: payload.userId,
					schoolClassId: payload.schoolClassId,
					...data
				}).then((response) => {

					context.commit('SET_EVALUATION_QUESTION_LIST', response.data);

					return response;

				});

			}

		},
	}
};



// WEBPACK FOOTER //
// ./sources/app/evaluation/store.js